import { Comment } from "@ant-design/compatible";
import "./comment.scss";
export default Comment;
